export enum ClientType {
  CLIENT = 'client',
  SUPPLIER = 'supplier',
  PERSONAL = 'personal',
}

export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  [ClientType.CLIENT]: 'Cliente',
  [ClientType.SUPPLIER]: 'Proveedor',
  [ClientType.PERSONAL]: 'Personal',
};

export interface Client {
  reference: string;
  name: string;
  phoneNumber?: string | null;
  clientType?: ClientType;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface CreateClientDto {
  name: string;
  phoneNumber: string;
  clientType?: ClientType;
}
